module.exports = __webpack_public_path__ + "img/affordacare copy.6fc2247c.png";